<div class="modal-header acm-header">
  <h5 class="modal-title acm-title">
    <i class="las la-sliders-h mr-2"></i>Configurar alertas identificadas
  </h5>
  <button type="button" class="close" (click)="dismiss()"><span>&times;</span></button>
</div>

<div class="modal-body acm-body">

  <!-- Mínimo de ocurrencias -->
  <div class="acm-section">
    <label class="acm-label">
      Ocurrencias mínimas
      <span class="acm-badge" [class.acm-badge--active]="minOccurrences > 0">
        {{ minOccurrences > 0 ? '≥ ' + minOccurrences : 'todas' }}
      </span>
    </label>
    <input
      type="range"
      class="acm-range"
      min="0" max="100" step="1"
      [(ngModel)]="minOccurrences"
      [style.--fill]="minOccurrences + '%'"
    />
    <div class="acm-ticks"><span>0</span><span>50</span><span>100</span></div>
  </div>

  <!-- Tipos de datos sensibles -->
  <div class="acm-section">
    <div class="acm-types-header">
      <div>
        <label class="acm-label mb-0">Tipos de datos sensibles</label>
        <div class="acm-types-hint">Elige los tipos que quieres incluir. Sin selección = todos.</div>
      </div>
      <div class="acm-types-actions">
        <button class="btn btn-link btn-sm p-0" (click)="clearAll()" [disabled]="loadingTypes">Quitar selección</button>
      </div>
    </div>

    <div *ngIf="loadingTypes" class="acm-loading">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <span class="ml-2 text-muted">Cargando tipos...</span>
    </div>

    <div *ngIf="!loadingTypes && availableTypes.length === 0" class="text-muted small mt-2">
      Sin datos disponibles para el período actual.
    </div>

    <div *ngIf="!loadingTypes && availableTypes.length > 0" class="acm-types-list">
      <label
        *ngFor="let t of availableTypes"
        class="acm-type-item"
        [class.acm-type-item--selected]="isSelected(t)"
        (click)="toggleType(t)"
      >
        <span class="acm-checkbox">
          <i class="las" [class.la-check-square]="isSelected(t)" [class.la-square]="!isSelected(t)"></i>
        </span>
        <span class="acm-type-name">{{ t }}</span>
      </label>
    </div>
  </div>

</div>

<div class="modal-footer acm-footer">
  <button class="btn btn-sm btn-outline-secondary mr-auto" (click)="reset()">
    <i class="las la-undo mr-1"></i>Quitar filtros
  </button>
  <button class="btn btn-sm btn-outline-dark" (click)="dismiss()">Cancelar</button>
  <button class="btn btn-sm btn-primary" (click)="apply()">
    <i class="las la-check mr-1"></i>Aplicar
  </button>
</div>
